// Device naam ke display-level alias.
//
// Field pe INC-WP-42 aur INC-WP-45 ko rebase kiya gaya hai, aur unke rebase
// version alag device ke roop me aate hain ("INC-WP-42 rebase"). Report me
// purana device nahi chahiye, aur rebase wale ka naam bina "rebase" ke aana
// chahiye — yaani user ko sirf "INC-WP-42" dikhe, data rebase wale ka.
//
// Ye sirf DISPLAY layer hai. DB/API bilkul touch nahi hota: id, device_profile
// aur telemetry sab waise ke waise rehte hain, sirf naam aur list badalti hai.
// Isi liye chart/table lookup hamesha row.id se hote hain, naam se nahi.

// Jaan-boojh ke hardcoded. Koi aur device "rebase" ho to wo apne-aap affect na
// ho — sirf yeh do handle karne hain.
const ALIASED_DEVICES = ["inc-wp-42", "inc-wp-45"];

// DB me asli naam "INC-WP-42-Rebaseline" hai (device table se confirm kiya),
// isliye "rebaseline" match karna zaroori hai — sirf "rebase" match karne se
// kuch nahi milta kyunki naam "line" par khatam hota hai.
//
// "line" optional rakha hai taaki agar aage koi device sirf "-Rebase" naam se
// aaye to wo bhi handle ho jaye. Case aur separator (space/dash/underscore)
// dono se farak nahi padta.
const REBASE_SUFFIX = /[\s_-]*rebase(?:line)?\s*$/i;

const norm = (name) => String(name ?? "").trim().toLowerCase();

/** "INC-WP-42 rebase" -> "INC-WP-42". Original casing preserve hoti hai. */
const stripRebase = (name) => String(name ?? "").replace(REBASE_SUFFIX, "").trim();

/** Kya ye un do device me se kisi ka rebase version hai? */
const isAliasedRebase = (name) =>
  REBASE_SUFFIX.test(String(name ?? "")) &&
  ALIASED_DEVICES.includes(norm(stripRebase(name)));

/** Kya ye purana (non-rebase) device hai jise chhupana hai? */
const isAliasedOriginal = (name) =>
  !REBASE_SUFFIX.test(String(name ?? "")) && ALIASED_DEVICES.includes(norm(name));

/**
 * Report/PDF me dikhne wala naam. Rebase wale ka suffix hat jaata hai, baaki
 * har device ka naam jaisa hai waisa hi rehta hai.
 */
export const displayDeviceName = (name) =>
  isAliasedRebase(name) ? stripRebase(name) : String(name ?? "");

/**
 * List me se purana INC-WP-42 / INC-WP-45 hata deta hai.
 *
 * Purana device tabhi hataya jaata hai jab uska rebase version isi list me
 * maujood ho. Warna (rebase device abhi is dashboard/profile me nahi aaya)
 * device poori tarah gayab ho jaata — chhupane se behtar hai use dikhne dena.
 */
export const withoutAliasedOriginals = (rows) => {
  const list = rows || [];
  const rebasedBases = new Set(
    list.filter((row) => isAliasedRebase(row?.name)).map((row) => norm(stripRebase(row.name)))
  );
  return list.filter((row) => !(isAliasedOriginal(row?.name) && rebasedBases.has(norm(row.name))));
};
